import { createFileRoute, redirect } from '@tanstack/react-router'

const githubRepositoryUrl = 'https://github.com/maxsjoberg00-coder/Spelltablez'

export const Route = createFileRoute('/github')({
  beforeLoad: () => {
    throw redirect({
      href: githubRepositoryUrl,
      statusCode: 307,
    })
  },
})
